export default __webpack_public_path__ + "static/media/session3.caed6297.svg";